import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import SignUp from './pages/SignUp';
import AppSelection from './pages/AppSelection';
import Dashboard from './pages/Dashboard';
import ProjectDetails from './pages/ProjectDetails';
import AccountManagement from './pages/AccountManagement';
import AdminAccountSetup from './components/AdminAccountSetup';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
//Admin based application with multiple assign.
function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<SignUp />} />
            <Route path="/app-selection" element={
              <ProtectedRoute>
                <AppSelection />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/project/:id" element={
              <ProtectedRoute>
                <Layout>
                  <ProjectDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/account-management" element={
              <ProtectedRoute>
                <AccountManagement />
              </ProtectedRoute>
            } />
            <Route path="/setup-admin" element={<AdminAccountSetup />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
